import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface InformationCardContentTotalSitesCardProps {
  props: any;
}

const InformationCardContentTotalSitesCard: React.FC<InformationCardContentTotalSitesCardProps> = ({ props }) => {
  const { t } = useTranslation();
  const metadata = useSelector((state: any) => state.metadata);

  if (!metadata?.sortedEntities || metadata?.entities?.length === 0) {
    return <></>;
  }

  let community = metadata?.sortedEntities?.communities.find(
    (community: any) =>
      community.id === metadata?.selectedEntityId ||
      community.communityId === metadata?.selectedEntityId
  );

  if (!community) {
    community = metadata?.sortedEntities?.communities[0];
  }

  const siteTypeCounts: Record<string, number | null> = {
    consumer: 0,
    producer: 0,
    prosumer: 0,
    prosumage: 0,
  };

  community.members.forEach((member: any) => {
    member.sites.forEach((site: any) => {
      if (Array.isArray(site.siteType)) {
        site.siteType.forEach((type: any) => {
          if (
            type.siteType &&
            Object.prototype.hasOwnProperty.call(siteTypeCounts, type.siteType)
          ) {
            siteTypeCounts[type.siteType]!++;
          }
        });
      } else if (typeof site.siteType === 'string') {
        if (siteTypeCounts.hasOwnProperty(site.siteType)) {
          siteTypeCounts[site.siteType]!++;
        }
      }
    });
  });

  for (const key in siteTypeCounts) {
    if (siteTypeCounts[key] === 0) {
      siteTypeCounts[key] = null;
    }
  }

  const keys = props.description.map((el: any) => el.key.split('.').slice(-1).pop());

  return (
    <>
      {keys
        .filter((el: any) => siteTypeCounts[el] !== null)
        .map((siteType: string, i: number, array: any) => {
          const label = props.description.find((desc: any) => desc.key.includes(siteType));
          return (
            <span key={`${props.id}-label-value-label-value-${i}`} className="paragraph">
              {t(label.key)} {siteTypeCounts[siteType]}{' '}
              {i < array.length - 1 ? '|' : ''}
            </span>
          );
        })}
    </>
  );
};

export default InformationCardContentTotalSitesCard; 